export default "__VITE_ASSET__femlXWQU__"